<template>
  <div >
    <el-select
      v-model="selectedCenterId"
      :disabled="readonly"
      :placeholder="$t('Seçin')"
      filterable
      size="small"
      clearable
      class="service-center-select"
      :class="{ 'large-size': size === 'normal' }"
    >
      <el-option
        v-for="center in serviceCenters"
        :key="center.id"
        :label="center.name"
        :value="center.id"
      />
    </el-select>
  </div>
</template>

<script>
import { GetActiveServiceCenters } from "../../services/cls";

export default {
  props: ['value', 'readonly', 'size'],
  data() {
    return {
      serviceCenters: [],
      selectedCenterId: null
    }
  },
  mounted() {
    this.getActiveServiceCenters();
  },
  watch: {
    value(newValue) {
      this.selectedCenterId = newValue;
    },
    serviceCenters(newValue) {
      if (this.value && newValue.length > 0) {
        this.selectedCenterId = this.value;
      }
    },
    selectedCenterId(newValue) {
      this.$emit('input', newValue);
    }
  },
  methods: {
    getActiveServiceCenters() {
      GetActiveServiceCenters().then((response) => {
        if (response.data.data) {
          this.serviceCenters = response.data.data;
        }
      });
    }
  }
}
</script>

<style scoped>

.service-center-select {
  width: 100%;
}


</style>